import { app } from '../../../../../../../bootstrap/core';

import { createRequestBranchIdsComponent } from './branchIds.component';

app.component(
  createRequestBranchIdsComponent.name,
  createRequestBranchIdsComponent,
);
